// extracted by mini-css-extract-plugin
export default {"item":"Menu_item__4Layc","isActive":"Menu_isActive__QtKQq"};